export const PENDING = 'pending';
export const PROCESSING = 'processing';
export const SIGNED = 'signed';
export const FAILED = 'failed';

export const MEDICAL_RECORD_RECIPE = 'medical_record_recipe';
export const MEDICAL_RECORD_DOCUMENT = 'medical_record_document';
export const MEDICAL_RECORD_ANAMNESIS = 'medical_record_anamnesis';
export const MEDICAL_RECORD_EXAM_REQUEST = 'medical_record_exam_request';
export const MEDICAL_RECORD_HOSPITALIZATION_REQUEST = 'medical_record_hospitalization_request';

export const statuses = {
  [PENDING]: 'Enviando para assinatura',
  [PROCESSING]: 'Aguardando o Bird ID',
  [SIGNED]: 'Assinado digitalmente',
  [FAILED]: 'Falha na assinatura',
};

export const documentKinds = {
  medical_certificate: 'Atestado médico',
  exam_request: 'Solicitação de exame',
  medical_report: 'Relatório médico',
};

export const pageSizes = ['A4', 'A5'];

export function getName(value) {
  return statuses[value];
}

export function isLocked(signature) {
  return !!signature && [PENDING, PROCESSING, SIGNED].includes(signature.status);
}

export function isRunning(signature) {
  return !!signature && [PENDING, PROCESSING].includes(signature.status);
}

export function getRecipeBlockedReason(recipe, { enabled, canSign }) {
  if (!enabled) {
    return 'Habilite a assinatura digital nas configurações de integrações';
  }
  if (!canSign) {
    return 'Somente o profissional do atendimento pode assinar esta receita';
  }
  if (recipe.origin === 'memed') {
    return 'Receitas da Memed são assinadas pela própria Memed';
  }
  if ((recipe.drugs || []).some(({ specialControl }) => specialControl)) {
    return 'Receitas com medicamento de controle especial não podem ser assinadas digitalmente';
  }
  return null;
}
